import {HttpContextToken} from '@angular/common/http';

export const SKIP_GLOBAL_ERROR_REDIRECT = new HttpContextToken<boolean>(() => false);
